import { useQuery } from '@apollo/client'

import { gql } from '@web/federation/gql'
import { federationApolloClient } from '@web/libs/apollo/federationClient'

const UsePlaceDetailQuery = gql(`
  query UsePlaceDetailQuery($placeId: String!) {
    placeDetail(id: $placeId, deviceType: MOBILE) {
      id
      registrationNumber
      address {
        elements {
          dong
        }
      }
      bookingAwards {
        award
        year
      }
      myStyleAwards {
        shop {
          year
          title
        }
      }
    }
  }
`)

/**
 * @description xbu Place에서만 제공하는 필드를 조회하기 위한 hook입니다. (단건조회)
 */
export const usePlaceDetailQuery = ({ placeId, skip }: { placeId: string; skip?: boolean }) => {
  const { data, loading, error } = useQuery(UsePlaceDetailQuery, {
    client: federationApolloClient,
    variables: { placeId: placeId! },
    skip: !placeId || skip,
  })

  return {
    data,
    loading,
    error,
  }
}
